export const USER_TOKEN_TYPES = ['author', 'assignee'];

export const DROPDOWN_TYPE = {
  hint: 'hint',
  operator: 'operator',
};
